import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Mirrors the permission the cost backend enforces. The two cannot share a
 * module — app code and backend code are separate bundles and neither may
 * import the other — so the name is the contract. Change it in both or the
 * route guard and the API guard drift apart.
 *
 * Backend copy: packages/backend/src/modules/costInsights.ts
 */
export const costReadAllPermission = createPermission({
  name: 'cost.all.read',
  attributes: { action: 'read' },
});
